import React from 'react';
import PropTypes from 'prop-types';
import withStaticBuilder from 'StaticBuilder/hocs/StaticBuilderField';
import CalendarFieldInput from 'StaticBuilder/CalendarField/CalendarFieldInput';
import CalendarFieldDatePicker from 'StaticBuilder/CalendarField/CalendarFieldDatePicker';
import { formatDate } from 'Utils';
import { ArrowLeftIcon, ArrowRightIcon } from 'DesignSystem/Icons';

class CalendarField extends React.Component {
  constructor(props) {
    super(props);

    let initialDate = new Date(this.props.value);
    if (isNaN(initialDate.getTime())) {
      initialDate = new Date();
    }

    this.state = {
      date: initialDate,
      showCalendar: false,
    };

    this.onClickDay = this.onClickTile.bind(this);
    this.onClickMonth = this.onClickTile.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.getDayAbbreviation = this.getDayAbbreviation.bind(this);
    this.getNextLabel = this.getNavigationLabel.bind(this, true);
    this.getPrevLabel = this.getNavigationLabel.bind(this, false);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.onMouseDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onMouseDown);
  }


  onFocus() {
    this.setState({
      showCalendar: true,
    });
  }

  onMouseDown(e) {
    if (!this.datepickerContainer.contains(e.target)) {
      this.setState({
        showCalendar: false,
      });
    }
  }

  onClickTile(date) {
    let dateChosen;
    if (this.props.isMobileOptimization) {
      dateChosen = formatDate(date, false);
    } else {
      dateChosen = formatDate(date);
    }

    this.props.onChange({
      target: {
        value: dateChosen,
      },
    });
    this.setState({
      date,
      showCalendar: false,
    });
  }

  getDayAbbreviation(value) {
    if (this.props.isMobileOptimization) {
      const dayLetters = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
      return dayLetters[value.getDay()];
    }
    return value.toString().substring(0, 2);
  }

  getNavigationLabel(isNext) {
    if (this.props.isMobileOptimization) {
      if (isNext) {
        return (<ArrowRightIcon className="ds-icon-inherit-color calendar-next-arrow" />);
      }
      return (<ArrowLeftIcon className="ds-icon-inherit-color calendar-previous-arrow" />);
    }
    return undefined;
  }

  render() {
    let placeholder = '';

    if (!this.props.value) {
      const today = new Date();

      if (this.props.isMobileOptimization) {
        placeholder = formatDate(today, false);
      } else {
        placeholder = formatDate(today);
      }
    }

    const datepickerTypes = [
      'calendar',
      'month',
    ];
    let datepickerType = this.props.datepickerType;
    if (datepickerTypes.indexOf(this.props.datepickerType) < 0) {
      datepickerType = 'calendar';
    }

    const datepickerTypeToMaxDetailType = {
      calendar: 'month',
      month: 'year',
    };

    return (
      <div
        className="calendar-field-container"
        ref={(node) => { this.datepickerContainer = node; }}
      >
        <CalendarFieldInput
          datepickerType={datepickerType}
          id={this.props.id}
          isMobileOptimization={this.props.isMobileOptimization}
          onChange={this.props.onChange}
          onFocus={this.onFocus}
          placeholder={placeholder}
          value={this.props.value}
        />

        <CalendarFieldDatePicker
          date={this.state.date}
          getDayAbbreviation={this.getDayAbbreviation}
          getNextLabel={this.getNextLabel}
          getPrevLabel={this.getPrevLabel}
          isMobileOptimization={this.props.isMobileOptimization}
          maxDetail={datepickerTypeToMaxDetailType[this.props.datepickerType]}
          onClickDay={this.onClickDay}
          onClickMonth={this.onClickMonth}
          showCalendar={this.state.showCalendar}
        />
      </div>
    );
  }
}

CalendarField.defaultProps = {
  isMobileOptimization: false,
  value: '',
  datepickerType: 'calendar',
};

CalendarField.propTypes = {
  id: PropTypes.string.isRequired,
  isMobileOptimization: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  datepickerType: PropTypes.string,
};

export default withStaticBuilder(CalendarField);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/CalendarField/index.jsx